import { createSlice } from '@reduxjs/toolkit';
import { revertAll } from '../actions';

export interface IToastState {
    show: boolean;
    isAlertOpen: boolean;
    message: string;
    severity: string;
}

const initialState: IToastState = {
    show: false,
    isAlertOpen: false,
    message: '',
    severity: 'success',
};

const toastSlice = createSlice({
    name: 'toast',
    initialState,
    reducers: {
        openToast: (state, action) => {
            return {
                ...state,
                show: action.payload.show,
                isAlertOpen: action.payload.isAlertOpen,
                message: action.payload.message,
                severity: action.payload.severity,
            };
        },
        resetToast: (state, action) => {
            return {
                ...state,
                isAlertOpen: action.payload.isAlertOpen,
                show: action.payload.show,
                message: action.payload.message,
            };
        },
    },
    extraReducers: builder => builder.addCase(revertAll, () => initialState),
});

export const { openToast, resetToast } = toastSlice.actions;
export const toastReducer = toastSlice.reducer;
